import { useMutation, useQueryClient } from '@tanstack/react-query';
import { type MutationOptions, gqlFetcher } from '../fetcher';
import { DeleteParticipant } from '../mutations/deleteParticipant.mutation';
import type { DeleteParticipantMutation, DeleteParticipantMutationVariables } from '../types';

export const useDeleteParticipantMutation = (
  options?: MutationOptions<DeleteParticipantMutation, DeleteParticipantMutationVariables>,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(DeleteParticipant), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes('participant'),
      });
    },
  });
};
